var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"subPage2"}},[_c('SubHeader'),_c('div',{staticClass:"subPage2"},[_c('SubMenu2')],1),_c('MainFooter',{staticClass:"subFooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }